import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataCapture } from 'src/app/model/data-capture';
import { CompleteApplicationData } from 'src/app/model/complete-application';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { CompleteApplicationService } from 'src/app/services/complete-application.service';
import { GENERIC_ERROR } from 'src/app/config/app-settings.config';
import { IwService } from 'src/app/services/iw.service';
declare var _satellite: any;

@Component({
  selector: 'app-add-card-features',
  templateUrl: './add-card-features.component.html',
  styleUrls: ['./add-card-features.component.scss']
})
export class AddCardFeaturesComponent implements OnInit {

  addFeatureForm:FormGroup;
  addCardFeature: DataCapture;
  caData: any;
  percentageAddCardFeature: string = "0%";
  @Input() step: any = 0;
  @Input() expanded:any;
  @Output() addCardFeatureValid = new EventEmitter<any>();
  eapplyFormPostQDELabel: any;
  qdeData: any;
  airIndiaCardList = ['AISU', 'AIPU', 'EGPU', 'EGSU'];
  showAirIndiaField = false;
  additionalFormVisible: boolean;
  expandAddCardFeature: any;
  errorMessage: string;
  hideSection:boolean=false;
  constructor(
    private fb:FormBuilder,
    private sharedService:SharedServiceService,
    private completeApp:CompleteApplicationService,
    private iw: IwService) { }

  ngOnInit() {
    this.eapplyFormPostQDELabel = this.iw.geteapplyFormPostQDEDCR();
    this.createForm();
    this.addCardFeature= new DataCapture();
    this.savePartialData();
    this.addFeatureForm.valueChanges.subscribe(values => {
      this.savePartialData();
    });
    this.qdeData = this.sharedService.qdeSubmitData;
    if (this.airIndiaCardList.includes(this.qdeData ? this.qdeData.WSCallCardType.toUpperCase() : '')) {
      this.showAirIndiaField = true;
    } else {
      this.showAirIndiaField = false;
    }
    if ((this.sharedService.qdeSuccessResponse && this.sharedService.qdeSuccessResponse.ckycStatus.toLowerCase() == 'success') || this.showAirIndiaField || (this.qdeData && this.qdeData.WSCallCardType == 'DCIU')) {
      this.additionalFormVisible = true;
    } else {
      this.additionalFormVisible = false;
    }
    this.getExpandStatus();
  }

  createForm(){
    this.addFeatureForm = this.fb.group({
      fcnActivateAll: [false],
      fcnOnlineDomestic: [false],
      fcnOnlineInternational: [false],
      fcnContactlessDomestic: [false],
      fcnContactlessInternational: [false],
      fcnPosAtm: [false],
      fcnConsent: [false],
    });
    //this.sharedService.updateAddCardFeatureForm({addCardFeatureForm:this.addFeatureForm.valid});
  }

  get f(){
    return  this.addFeatureForm.controls;
  }

  savePartialData(){
    this.addCardFeature.domesticOnline = this.f.fcnOnlineDomestic.value ? (this.f.fcnOnlineDomestic.value==true ? 'Y':'N') : 'N';
    this.addCardFeature.internationalOnline = this.f.fcnOnlineInternational.value ? (this.f.fcnOnlineInternational.value==true ? 'Y':'N') : 'N';
    this.addCardFeature.contactlessDomestic = this.f.fcnContactlessDomestic.value ? (this.f.fcnContactlessDomestic.value==true ? 'Y':'N') : 'N';
    this.addCardFeature.contactlessInternational = this.f.fcnContactlessInternational.value ? (this.f.fcnContactlessInternational.value==true ? 'Y':'N') : 'N';
    this.addCardFeature.posInternational = this.f.fcnPosAtm.value ? (this.f.fcnPosAtm.value==true ? 'Y':'N') : 'N';
    this.addCardFeature.consentGiven = 'Y';
    this.completeApp.addCardFeatureData = this.addCardFeature;
    console.log('addcardFeature form ', this.addFeatureForm);
    
   // this.sharedService.updateAddCardFeatureForm({addCardFeatureForm:this.addFeatureForm.valid});

    this.caData = new CompleteApplicationData();
    this.caData.WSCallContactlessDomestic = this.f.fcnContactlessDomestic.value ? (this.f.fcnContactlessDomestic.value==true ? 'Y':'N') : 'N';
    this.caData.WSCallContactlessInternational = this.f.fcnContactlessInternational.value ? (this.f.fcnContactlessInternational.value==true ? 'Y':'N') : 'N';
    this.caData.WSCallDomesticOnline = this.f.fcnOnlineDomestic.value ? (this.f.fcnOnlineDomestic.value==true ? 'Y':'N') : 'N';
    this.caData.WSCallInternationalOnline = this.f.fcnOnlineInternational.value ? (this.f.fcnOnlineInternational.value==true ? 'Y':'N') : 'N';
    this.caData.WSCallPosInternational = this.f.fcnPosAtm.value ? (this.f.fcnPosAtm.value==true ? 'Y':'N') : 'N';
    this.caData.WSCallOnlinePosAtmConsent = 'Y';
    // this.caData.WSCallUserApplicationNumber = this.sharedService.qdeSuccessResponse && this.sharedService.qdeSuccessResponse.applicationNumber ? this.sharedService.qdeSuccessResponse.applicationNumber : '';
    this.sharedService.cAadditionalCardFeatureData = this.caData;
}

selectAll(){
  
    if(this.f.fcnActivateAll.value && this.f.fcnActivateAll.value===true){
     this.addFeatureForm.patchValue({
        fcnActivateAll: true,
        fcnOnlineDomestic: true,
        fcnOnlineInternational: true,
        fcnContactlessDomestic: true,
        fcnContactlessInternational: true,
        fcnPosAtm: true,
      }) 
    } else{
      this.addFeatureForm.patchValue({
        fcnActivateAll: false,
        fcnOnlineDomestic: false,
        fcnOnlineInternational: false,
        fcnContactlessDomestic: false,
        fcnContactlessInternational: false,
        fcnPosAtm: false,
       }) 
    }
  }

  setApplicationData() {
    let reqObj = Object.assign({}, this.sharedService.qdeSubmitData, this.caData, this.sharedService.cAprofessisonalData, this.sharedService.cApersonalData, this.sharedService.cAadditionalData);
    reqObj = this.trimObject(reqObj);
    this.completeApp.saveUpdateApplication(reqObj).subscribe((result: any) => {
      if (result && result.DataCaptureRes && result.DataCaptureRes.WSCallStatus && result.DataCaptureRes.WSCallStatus.toLowerCase() === 'success') {
        this.sharedService.dcSeqId = result.DataCaptureRes.WSCallSequenceId;
        this.errorMessage ='';
          // this.addCardFeatureValid.emit({
          //   addCardFeatureValid : this.addFeatureForm.valid
          // });
        //this.sharedService.updateAddCardFeatureForm({addCardFeatureForm:this.addFeatureForm.valid});
        this.sharedService.setAddDetailsOpenState({expand: true, step:3});
      } else {
        window["digitalData"].error = { message: GENERIC_ERROR };
        if(window['_satellite']){
          _satellite.track('form_error');
        }
        this.errorMessage =GENERIC_ERROR;
      }
    }, (error) => {
      window["digitalData"].error = { message: GENERIC_ERROR };
      if(window['_satellite']){
        _satellite.track('form_error');
      }
      this.errorMessage =GENERIC_ERROR;
    })
  }

  trimObject(object) {
    object = Object.assign({}, object);
    let keys = Object.keys(object);
    keys.forEach(element => {
      if (typeof object[element] == "string" && object[element]) {
        object[element] = object[element].trim();
      } else if (typeof object[element] == "object" && object[element] && element != 'WSCallUserDOB' && element != 'dateOfBirth') {
        object[element] = this.trimObject(object[element]);
      }
    });
    return object;
  }

  setPercentagePersonal() {
    console.log(this.f.fcnConsent.value);
    if(!this.f.fcnConsent.value){
      this.percentageAddCardFeature = "100%";
      this.addCardFeatureValid.emit({
        addCardFeatureCheckboxEnabled : true
      });
    }else{
      this.percentageAddCardFeature = "0%";
      this.addCardFeatureValid.emit({
        addCardFeatureCheckboxEnabled : false
      });
    }
  }

  additionalExpand(){
    this.setApplicationData();
  }

  getExpandStatus(){
    this.sharedService.openAddCardFeatureObservable.subscribe((status: any)=>{
      console.log('steps',status.expand, status.step);
      
      this.expandAddCardFeature = status.step;
    })
  }

  toggleAllOption(){
    if(this.f.fcnOnlineDomestic.value===false || this.f.fcnOnlineInternational.value===false ||
      this.f.fcnContactlessDomestic.value===false || this.f.fcnContactlessInternational.value ===false ||
      this.f.fcnPosAtm.value===false
      ){
      this.addFeatureForm.patchValue({
        fcnActivateAll:false
      })
    }else{
      this.addFeatureForm.patchValue({
        fcnActivateAll:true
      })
    }
  }

  
}
